import { FormBase } from 'core/components';
import _ from 'lodash';

export const baseScheduleProperties = {
    fields: [
        {
            name: 'startDate',
            label: 'FACILITY.SCHEDULE.START_DATE_LABEL',
            placeholder: 'FACILITY.SCHEDULE.START_DATE_PLACEHOLDER',
            rules: 'required'
        },
        {
            name: 'dayOfTheWeek',
            label: 'FACILITY.SCHEDULE.DAY_OF_THE_WEEK_LABEL',
            placeholder: 'FACILITY.SCHEDULE.DAY_OF_THE_WEEK_PLACEHOLDER',
            rules: 'required',
            type: 'integer'
        },
        {
            name: 'weeks',
            label: 'FACILITY.SCHEDULE.WEEKS_LABEL',
            placeholder: 'FACILITY.SCHEDULE.WEEKS_PLACEHOLDER',
            rules: 'required|integer|min:1',
            type: 'integer'
        },
        {
            name: 'orderingScheduleNoOfDays',
            label: 'FACILITY.SCHEDULE.ORDERING_SCHEDULE_NO_OF_DAYS_LABEL',
            placeholder: 'FACILITY.SCHEDULE.ORDERING_SCHEDULE_NO_OF_DAYS_PLACEHOLDER',
            type: 'integer'
        }
    ]
};

export const scheduleProperties = {
    fields: _.union(baseScheduleProperties.fields, [{
        name: 'areaOfCareId',
        label: 'FACILITY.SCHEDULE.AREA_OF_CARE_LABEL',
        rules: 'required'
    }])
};

export default class FacilityScheduleForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'facilitySchedule',
                    fields: [ ...baseScheduleProperties.fields ]
                },
                {
                    name: 'schedules'
                }
            ]
        };
    }
}

// const properties = {
// // struct: [
// //     'schedules[]',
// //     'schedules[].areaOfCareId',
// //     'schedules[].startDate',    
// //     'schedules[].dayOfTheWeek',
// //     'schedules[].weeks'
// // ],
// fields: [
//     'facilitySchedule.startDate',        
//     'facilitySchedule.dayOfTheWeek',
//     'facilitySchedule.weeks',
//     'schedules',
//     'schedules[].startDate',    
//     'schedules[].dayOfTheWeek',
//     'schedules[].weeks',
//   ],
//   rules: {
//     'facilitySchedule.startDate':       'required',            
//     'facilitySchedule.dayOfTheWeek':    'required',
//     'facilitySchedule.weeks':           'required',
//     // 'schedules[].areaOfCareId':           'required|string',
//     // 'schedules[].startDate':              'required',    
//     // 'schedules[].dayOfTheWeek':           'required',
//     // 'schedules[].weeks':                  'required',
//   },
//   labels: {
//     'facilitySchedule.startDate':      'FACILITY.SCHEDULE.START_DATE_LABEL',
//     'facilitySchedule.dayOfTheWeek':   'FACILITY.SCHEDULE.DAY_OF_THE_WEEK_LABEL',
//     'facilitySchedule.weeks':          'FACILITY.SCHEDULE.WEEKS_LABEL',    
//     // 'schedules[].areaOfCareId':   'FACILITY.SCHEDULE.AREA_OF_CARE_LABEL',    
//     // 'schedules[].startDate':      'FACILITY.SCHEDULE.START_DATE_LABEL',
//     // 'schedules[].dayOfTheWeek':   'FACILITY.SCHEDULE.DAY_OF_THE_WEEK_LABEL',
//     // 'schedules[].weeks':          'FACILITY.SCHEDULE.WEEKS_LABEL',
//   }
// };

// export default class FacilitySchedulelForm extends FormBase {
//     constructor(hooks) {
//         super(hooks);
//     }

//     setup() {
//         return properties;
//     }
// }
